<template>
  <q-btn
    icon="fa fa-plus"
    label="Create Album"
    v-bind="$attrs"
    @click="openModal"/>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { Client, Report } from '@/type';
import openModal from '@/components/modal';
import CreateAlbumModal from './CreateAlbumModal.vue';

export default defineComponent({
  emits: ['created'],
  props: {
    clientId: {
      type: Number,
      required: true,
    },
  },
  methods: {
    openModal() {
      const config = {
        parent: this,
        clientId: this.clientId,
      };
      openModal(CreateAlbumModal, config)
        .onOk((report: Report) => {
          this.$emit('created', report);
        });
    },
  },
});
</script>
